<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备详情
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="rms-equip-detail flex" :class="{ 'is-collapse': collapse }">
    <div class="hd">
      <div class="bg-white flex" style="padding: 12px 15px;">
        <div class="hd">
          <el-autocomplete
            ref="auto-search"
            :style="{ width: '220px' }"
            prefix-icon="el-icon-search"
            v-model="searchId"
            clearable
            popper-class="equip-popper"
            placeholder="输入设备GO码或名称"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
          >
            <div slot-scope="{ item }" style="line-height:20px;" class="pt-sm pb-sm">
              <div class="text-bold">{{ item.name }}</div>
              <div class="font-sm text-secondary">{{ item.go }}</div>
            </div>
          </el-autocomplete>
        </div>
        <div class="bd flex-center">
          <el-popover
            v-model="conditionShow"
            placement="bottom-start"
            width="600"
            trigger="manual"
            popper-class="pl-lg pr-lg pt-md pb-md"
            title="筛选"
            :visible-arrow="false"
          >
            <el-form
              ref="postForm"
              label-position="left"
              label-width="80px"
              :model="query"
              class="pl-lg pr"
            >
              <el-form-item label="状态">
                <f-radio-btn-group v-model="query.equip_status" :groups="equipEventTypeArr" border />
              </el-form-item>
              <el-form-item label="模型">
                <f-dev-selector v-model="query.devid" width="160" />
              </el-form-item>
              <el-form-item label="标签">
                <EquipTagSelector v-model="query.tagid" width="160" />
              </el-form-item>
              <el-form-item label="分组">
                <EquipGroupSelector v-model="query.groupid" width="160" />
              </el-form-item>
            </el-form>
            <span class="pl-lg dialog-footer">
              <el-button type="primary" size="small" @click="ensureCondition()">确定</el-button>
              <el-button size="small" @click="resetCondition()">重置</el-button>
            </span>
            <span class="font-lg" slot="reference" role="button">
              <i
                class="iconfont icon-filter image small flex-center ml-sm rounded bg-hover"
                :class="[ (conditionShow || hasCondition) && 'text-primary', !conditionShow && !hasCondition && 'text-secondary', !conditionShow && hasCondition && 'bg-primary-light', conditionShow && 'bg-light' ]"
                @hover="conditionShow = true"
                @click="conditionShow = !conditionShow"
              ></i>
            </span>
          </el-popover>
        </div>
      </div>
      <el-scrollbar
        v-loading="listLoading"
        ref="scroll-list"
        class="equip-list bg-white flex column"
      >
        <div class="hd" :style="{height: listHeight + 'px'}" style="position:relative;">
          <template v-for="(e,index) in activeList">
            <div
              :id="'e' + e.equipid"
              :key="'equip' + e.equipid"
              class="equip-item bg-hover flex"
              :style="{ top: (pre + index) * itemHeight + 'px'}"
              :class="[ activeId == e.equipid && 'bg-primary-light' ]"
              role="button"
              @click="toDetail(e.equipid)"
            >
              <div class="equip-item__inner flex align-items-center">
                <div class="hd">
                  <img
                    v-if="!e.is_online"
                    src="@/assets/status-offline.jpg"
                    class="image hg rounded"
                  />
                  <img
                    v-else-if="e.is_alarm"
                    src="@/assets/status-alarming-list.gif"
                    class="image hg rounded"
                  />
                  <img
                    v-else-if="e.is_running"
                    src="@/assets/status-running-list.gif"
                    class="image hg rounded"
                  />
                  <img v-else src="@/assets/status-online-list.gif" class="image hg rounded" />
                </div>
                <div class="bd pl" style="overflow: hidden;">
                  <div class="ellipsis">{{ e.name }}</div>
                  <div v-if="e.expired" class="mt-xs text-danger ellipsis font-sm">
                    <div
                      v-if="now - e.expire_day > oneDay"
                    >{{ e.expire_day | parseTime('{y}/{m}/{d}') }} 服务已到期</div>
                    <div v-else>{{ e.expire_day | formatTime }} 服务已到期</div>
                  </div>
                  <div v-else class="mt-xs">
                    <span
                      v-if="!e.is_online && !e.expired"
                      class="font-sm text-muted"
                    >{{ e.last_parser_time | formatTime }} {{ e.status }}</span>
                    <span v-if="e.is_online && !e.expired" class="font-sm text-muted">{{ e.status }}</span>
                  </div>
                </div>
                <div v-if="!e.expired" class="ft">
                  <span class="font-md">{{ e.current_value || '--'}}</span>
                  <span v-if="e.current_value" class="text-muted font-sm ml-xs">{{ e.unit_value }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="bd bg-white flex-center">
          <p v-if="!activeList.length" class="text-center text-muted">暂无数据</p>
        </div>
      </el-scrollbar>
    </div>
    <div class="bd flex-center" style="width:100%;height:calc(100vh - 60px);">
      <iframe
        v-show="activeList.length"
        id="iframe"
        :src="iframeUrl"
        frameborder="0"
        style="width:100%;height:100%;"
      ></iframe>
      <div v-show="!activeList.length" class="text-secondary font-lg pb-lg">
        <span class="font-10x flex" style="opacity: 0.2;">
          <i class="iconfont icon-dtu" />
        </span>
        <div class="text-center font-sm">请选择设备</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from "@/utils/cookie";
import { equipGetallApi, fetchEquipsStateApi } from "@/api/rms/rmsEquipApi";
import { virtualDebounce } from "@/utils/common";
import { getEquipDynamicInfoApi } from "@/api/rms/rmsEquipApi";

export default {
  name: "RmsEquipDetail",

  props: {
    itemHeight: {
      type: Number,
      default: 70,
    },
  },
  components: {
    EquipTagSelector: () => import("./components/EquipTagSelector"),
    EquipGroupSelector: () => import("./components/EquipGroupSelector"),
  },

  data() {
    return {
      equipid: Number(this.$route.params.equipid),
      now: null,
      loading: false,

      listLoading: false,
      conditionShow: false,
      query: {
        equip_status: 0,
        devid: null,
        tagid: null,
      },
      equipEventTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 2, title: "离线" },
        { value: 3, title: "在线" },
        { value: 5, title: "运行" },
        { value: 4, title: "告警" },
      ],

      iframeUrl: "",
      eList: [],
      activeId: null,

      oneDay: 24 * 60 * 60,
      searchId: null,
      allPages: 0,
      pageHeight: this.itemHeight * 20,
      // activeList: [],
      currentPage: 0,
      listHeight: 0,
      listRequest: null,
      topFixHeight: 0,

      intervalTime: 10 * 1000,
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
    hasCondition() {
      return Boolean(
        this.query.equip_status || this.query.devid || this.query.tagid
      );
    },
    pre() {
      return this.currentPage ? this.currentPage * 20 - 20 : 0;
    },
    activeList() {
      let arr = this.eList.slice(this.pre, (this.currentPage + 2) * 20);
      return arr;
    },
    equipids() {
      return this.activeList.map((item) => {
        return item.equipid;
      });
    },
  },

  created() {
    if (this.$route.params.equipid)
      sessionStorage.setItem("__EQUIPID__", this.$route.params.equipid);
    else this.equipid = Number(sessionStorage.getItem("__EQUIPID__"));

    this.activeId = this.equipid;
    this.now = parseInt(new Date().getTime() / 1000);
    const source = encodeURIComponent(window.location.href);
    const accessToken = encodeURIComponent(getAccessToken());
    this.iframeUrl = `${process.env.VUE_APP_RMS_HOST}/#/home/detail?equipid=${this.equipid}&access_token=${accessToken}&source=${source}&openMethod=embed`;
    this.listRequest = this.fetchList();
    this.interval = setInterval(() => {
      this.updateList();
    }, this.intervalTime);
  },

  mounted() {
    this.handleScroll();
    this.listRequest.then((res) => {
      const list = res.data.list;
      const index = list.findIndex((item) => {
        return item.equipid == this.activeId;
      });
      this.currentPage = parseInt((index * this.itemHeight) / this.pageHeight);
      this.$refs["scroll-list"].wrap.scrollTop = index * this.itemHeight;
    });
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    async fetchList() {
      this.listLoading = true;
      this.searchId = null;
      let res = await equipGetallApi(this.query);
      this.listLoading = false;
      if (!res.errno) {
        this.eList = res.data.list.map(i => {
          if (i.is_online && i.is_alarm && i.is_running) i.status = '告警运行'
          if (i.is_online && i.is_alarm && !i.is_running) i.status = '告警'
          if (i.is_online && !i.is_alarm && i.is_running) i.status = '正常运行'
          if (i.is_online && !i.is_alarm && !i.is_running) i.status = '在线'
          return i
        })
        let { length } = res.data.list;
        let page = parseInt(length / 20);
        this.allPages = length % 20 ? page + 1 : page;
        this.listHeight = length * this.itemHeight;

        const index = this.eList.findIndex((item) => {
          return item.equipid == this.activeId;
        });
        this.currentPage = parseInt(
          (index * this.itemHeight) / this.pageHeight
        );
        let _this = this;
        this.$nextTick(() => {
          _this.updateList();
        });
      } else {
        this.$message.error(res.message);
      }
      return res;
    },

    async ensureCondition() {
      this.conditionShow = false;
      await this.fetchList();
      if (this.eList.length) this.toDetail(this.activeList[0].equipid);
      this.currentPage = 0;
      this.$refs["scroll-list"].wrap.scrollTop = 0;
    },

    resetCondition() {
      this.query = {
        status: 0,
        devid: null,
        tagid: null,
      };
      this.ensureCondition();
    },

    toDetail(id) {
      this.activeId = id;
      sessionStorage.setItem("__EQUIPID__", id);
      let iframe = document.getElementById("iframe");
      iframe.contentWindow.postMessage(id, process.env.VUE_APP_RMS_HOST);
    },

    handleScroll() {
      let scrollbarEl = this.$refs["scroll-list"].wrap;
      let _this = this;
      scrollbarEl.onscroll = virtualDebounce(function (event) {
        _this.topFixHeight = event.target.scrollTop;
        _this.currentPage = parseInt(event.target.scrollTop / _this.pageHeight);
      }, 10);
    },

    querySearch(queryString, cb) {
      getEquipDynamicInfoApi({ keyword: queryString, num: 10 }).then((res) => {
        if (!res.errno) {
          cb(res.data.list);
        } else {
          cb([]);
        }
      });
    },

    createFilter(queryString) {
      return (equip) => {
        return (
          equip.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1 ||
          equip.go.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },

    handleSelect(item) {
      let e = item.equipid;
      this.searchId = item.name;
      if (e) {
        const index = this.eList.findIndex((item, index) => {
          return item.equipid == e;
        });
        if (index > -1) {
          let re = this.eList.splice(index, 1);
          this.activeId = re[0].equipid;
          this.eList.unshift(re[0]);
        } else {
          this.eList.unshift(item);
        }
        this.updateList();

        this.currentPage = 0;
        this.$refs["scroll-list"].wrap.scrollTop = 0;
        this.toDetail(e);
      }
    },

    updateList() {
      const _this = this;
      if (!this.equipids.length) return;
      fetchEquipsStateApi({ equipids: this.equipids }).then((res) => {
        if (res.errno) {
          this.$message.error(res.message);
          return;
        }
        let obj = res.data.state;
        //更新当前显示的设备状态，同时查询是否发生变更，变更则从列表中删除
        const newarr = _this.activeList.map((item, index) => {
          let temp = item;
          if (obj[item.equipid]) {
            let tempObj = Object.assign({}, obj[item.equipid])
            if (tempObj.is_online && tempObj.is_alarm && tempObj.is_running) tempObj.status = '告警运行'
            if (tempObj.is_online && tempObj.is_alarm && !tempObj.is_running) tempObj.status = '告警'
            if (tempObj.is_online && !tempObj.is_alarm && tempObj.is_running) tempObj.status = '正常运行'
            if (tempObj.is_online && !tempObj.is_alarm && !tempObj.is_running) tempObj.status = '在线'
            temp = Object.assign(temp, tempObj);
            // _this.eList.splice(this.pre + index, 1, item);
          }
          return temp;
        });
        _this.eList.splice(_this.pre, _this.activeList.length, ...newarr);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.equip-popper {
  .el-select-dropdown__item {
    height: auto;
    padding: 5px 15px;
  }
  li {
    padding: 5px 20px;
    height: auto;
  }
  // position: sticky;
}
.tool-popper {
  padding: 30px;
}
.rms-equip-detail {
  margin-left: -20px;
  margin-right: -20px;
  .equip-list {
    width: 300px;
    z-index: 12;
    height: calc(100vh - 120px);
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    .equip-item {
      position: absolute;
      left: 0;
      right: 0;
      padding: 0 15px;
      height: 70px;
      .equip-item__inner {
        width: 100%;
        border-bottom: 1px solid #ebeef5;
      }
    }
  }
  .offline {
    background-color: #4c4c4c;
  }
  .online {
    background-color: #409eff;
  }
  .running {
    background-color: #3bb471;
  }
  .alarm {
    background-color: #e05151;
  }

  .bg-primary-light {
    background-color: rgba(7, 193, 96, 0.05) !important;
  }
}
</style>
